module.exports = __webpack_public_path__ + "img/3.6593877e.png";